module.exports = __webpack_public_path__ + "img/abacus_type_demo_1.f492f986.png";